import OptimizerEditDto from "./OptimizerEditDto";

export class NewtonCGOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.xtol = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.c1 = null;
        /** @type {number} */
        this.c2 = null;
        /** @type {number} */
        this.eps = null;
    }

    /**
     * @typedef {Object} _NewtonCGOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} xtol
     * @property {number} tol
     * @property {number} c1
     * @property {number} c2
     * @property {number} eps
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _NewtonCGOptimizerEditDtoProps} NewtonCGOptimizerEditDtoProps
     */
    /**
     * 
     * @param {NewtonCGOptimizerEditDtoProps} props
     * @returns {NewtonCGOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.xtol = props.xtol;
        this.tol = props.tol;
        this.c1 = props.c1;
        this.c2 = props.c2;
        this.eps = props.eps;
        return this;
    }
}

export default NewtonCGOptimizerEditDto;